import { gql } from "@apollo/client";

export const QUERY_FEED_LIST = gql`
  query merchantFeedList($offset: Int = 0, $limit: Int = 10) {
    merchantFeedList(offset: $offset, limit: $limit)
  }
`;

export const QUERY_MERCHANT_FEED = gql`
  query merchantFeed($feedId: Int!) {
    merchantFeed(feedId: $feedId)
  }
`;

export const QUERY_PRODUCT_REVIEW_LIST = gql`
  query productReviewList(
    $merchantId: Int
    $offset: Int! = 0
    $limit: Int! = 10
    $productCode: String
    $sortOrder: SortOrder = DESC
    $sortBy: ReviewSortField
  ) {
    productReviewList(
      merchantId: $merchantId
      offset: $offset
      limit: $limit
      productCode: $productCode
      sortOrder: $sortOrder
      sortBy: $sortBy
    ) {
      id
      comment
      rating
      createdAt
      updatedAt
      customer {
        id
        name
        phoneNumber
      }
      productId
      helpful
      hasMarkedHelpful
      product {
        id
        picture
        title
        thumbnail
        thumbnailSquare
        code
        color
        size
        price
        priceBeforeDiscount
        descriptionHTML
        isWishList
        returnable
        availability
      }
    }
  }
`;

export const QUERY_SUPPLIER_REQUEST_LIST = gql`
  query supplierProductRequestList(
    $offset: Int = 0
    $limit: Int = 10
    $filter: FilterSupplierRequest
    $brand: [Int]
    $vendor: [Int]
    $tags: [String]
    $stockOnly: Boolean
    $remoteStock: Boolean
    $offerDiscount: Boolean
  ) {
    supplierProductRequestList(
      offset: $offset
      limit: $limit
      filter: $filter
      brand: $brand
      vendor: $vendor
      tags: $tags
      stockOnly: $stockOnly
      remoteStock: $remoteStock
      offerDiscount: $offerDiscount
    ) {
      data {
        id
        content
        status
        rejectedReason
        soldQty
        revenue
        type
        brand {
          id
          name
        }
        vendor {
          id
          name
        }
        option {
          remoteStock
          remoteDuration {
            from
            to
          }
          colorList {
            value
            sizeList {
              value
              skuId
              actualQty
              price
              priceBeforeDiscount
            }
          }
        }
      }
      page {
        current
        size
        total
      }
    }
  }
`;
